export default __webpack_public_path__ + "static/media/wc.a11eac1c.png";